import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

import { SpinnerService } from '@shared/spinner/spinner.service';

import { AppConfigService } from '@core/api/app-config.service';

@Injectable()
export class AppConfigEffects {

  constructor(
    readonly actions$: Actions,
    readonly appConfigService: AppConfigService,
    readonly spinnerService: SpinnerService
  ) {}
}
